import {createAction} from 'redux-actions';

export const setGrayscaleMode = createAction('SET_GRAYSCALE_MODE');
